/**
 * Apply loading state to kotlin-code elements immediately on page load
 * This prevents FOUC by showing a loading spinner until CodeMirror is initialized
 */
(function() {
  // Apply loading class to all kotlin-code elements as soon as possible
  function applyLoadingState() {
    const kotlinCodeElements = document.querySelectorAll('.kotlin-code, code.kotlin-code, pre > code.kotlin-code');
    kotlinCodeElements.forEach(element => {
      // Don't add loading class if already initialized
      if (!element.getAttribute('data-kotlin-playground-initialized')) {
        element.classList.add('kotlin-code-loading');
      }
    });
  }
  
  // Apply immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLoadingState);
  } else {
    applyLoadingState();
  }
  
  // Also apply for any dynamically added content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          if (node.classList && node.classList.contains('kotlin-code') && 
              !node.getAttribute('data-kotlin-playground-initialized')) {
            node.classList.add('kotlin-code-loading');
          }
          // Check descendants
          const kotlinElements = node.querySelectorAll ? 
            node.querySelectorAll('.kotlin-code:not([data-kotlin-playground-initialized])') : [];
          kotlinElements.forEach(el => el.classList.add('kotlin-code-loading'));
        }
      });
    });
  });
  
  // Start observing when DOM is ready
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
